import { Resource } from 'Workspace/ResourceProvider/resourceTypes';

export function supportsIcaLaunch(resource: Resource) {
	return resource.clienttypes && resource.clienttypes.includes('ica30');
}
